import { throttle } from 'lodash';
import { forwardRef, useEffect, useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';

const VisualViewport = forwardRef(
  (
    {
      as: Component = Box,
      children,
      isFixed,
      style = {},
      wrapScroll,
      ...props
    },
    ref,
  ) => {
    const [viewport, setViewport] = useState({});

    const updateViewport = throttle(
      () => {
        if (wrapScroll && ref?.current) {
          const style = window.getComputedStyle(ref.current);
          const marginTop = parseInt(style.marginTop, 10) || 0;

          setViewport({
            maxHeight:
              (window?.visualViewport?.height ?? window.innerHeight) -
              marginTop * 2,
            maxWidth: window?.visualViewport?.width ?? window.innerWidth,
          });
        }
      },
      100,
      { trailing: true },
    );

    useEffect(() => {
      if (typeof window !== 'undefined') {
        updateViewport();

        if (typeof window.visualViewport !== 'undefined') {
          window.visualViewport.addEventListener('resize', updateViewport);

          return () =>
            window.visualViewport.removeEventListener('resize', updateViewport);
        }

        window.addEventListener('resize', updateViewport);

        return () => window.removeEventListener('resize', updateViewport);
      }
    }, []);

    return (
      <Component
        display="block"
        ref={ref}
        style={{ ...style, ...viewport }}
        {...props}
      >
        {children}
      </Component>
    );
  },
);

export default VisualViewport;
